import { getWeekdayByDate, getMonthByDate, dateToYYYYMMDD } from "./datetime";

export function createTimeSlots(){
	let slots = [];
	const date = new Date (2024, 0, 1, 9, 30, 0, 0);

	for (let index = 0; index < 25; index++) {
		date.setMinutes ( date.getMinutes() + 30);
		slots.push(date.getHours() + ':' + (date.getMinutes() < 9 ? '0' : '') + date.getMinutes())
	}
	return slots;
}

export function createTimeSlotsForRecord(){
	let slots = [];
	const date = new Date (2024, 0, 1, 9, 0, 0, 0);

	for (let index = 0; index < 13; index++) {
		date.setMinutes ( date.getMinutes() + 60);
		slots.push(date.getHours() + ':' + (date.getMinutes() < 9 ? '0' : '') + date.getMinutes())
	}
	return slots;
}

export function createTimeSlotsForSpecialist(startSeconds = 36000, endSeconds = 79200) {
    const startDate = new Date(2024, 0, 1);
    startDate.setSeconds(startSeconds);
    
    const endDate = new Date(2024, 0, 1);
    endDate.setSeconds(endSeconds);
    
    const cutoffDate = new Date(endDate);
    cutoffDate.setSeconds(cutoffDate.getSeconds() - 7200);

    let slots = [];
    let current = new Date(startDate);

    while (current <= cutoffDate) {
        const hours = current.getHours().toString().padStart(2, '0');
        const minutes = current.getMinutes().toString().padStart(2, '0');
        slots.push(`${hours}:${minutes}`);

        current.setSeconds(current.getSeconds() + 1800);
    }

    return slots;
}

export function createTimeSlotsWithHoursSum(startSeconds = 36000, endSeconds = 79200) {
    const startDate = new Date(2024, 0, 1);
    startDate.setSeconds(startSeconds);
    
    const endDate = new Date(2024, 0, 1);
    endDate.setSeconds(endSeconds);

    const startDatePlus2Hours = new Date(startDate);
    startDatePlus2Hours.setSeconds(startDatePlus2Hours.getSeconds() + 7200);

    const slots = [];
    let currentTime = new Date(startDatePlus2Hours);

    while (currentTime <= endDate) {
        const hours = currentTime.getHours().toString().padStart(2, '0');
        const minutes = currentTime.getMinutes().toString().padStart(2, '0');
        const timeString = `${hours}:${minutes}`;

        const diffMs = currentTime - startDate;
        const diffHours = parseFloat((diffMs / (1000 * 60 * 60)).toFixed(1));

        slots.push({
            time: timeString,
            hoursSum: `${diffHours} ч.`
        });

        currentTime.setSeconds(currentTime.getSeconds() + 1800);
    }

    return slots;
}

export function createWeekColumns(periodArray){
	if(!periodArray) return [];

	let result = [];
	const today = new Date();

	const firstDay = periodArray[0];
	let date = new Date(firstDay);

	for (let index = 0; index < 7; index++) {
		if(index > 0){
			date.setHours(date.getHours() + 24);
		}
		result.push({
			dateStr: date.getDate() + ' ' + getMonthByDate(date, true),
			weekDay: getWeekdayByDate(date, true),
			date: dateToYYYYMMDD(date),
			today: dateToYYYYMMDD(date) === dateToYYYYMMDD(today),
			past: date < today,
		})
	}

	return result
}


export function createMonthsColumns(periodArray) {
    if (!periodArray || periodArray.length < 2) return [];

    const result = [];
    const today = new Date();

    // Парсим начало и конец указанного периода
    const startDate = new Date(periodArray[0]);
    const endDate = new Date(periodArray[1]);

    const firstDayOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    let currentDate = new Date(firstDayOfMonth);

    const endOfStartMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    const finalEndDate = endDate < endOfStartMonth ? endDate : endOfStartMonth;

    while (currentDate <= finalEndDate) {
        const dateFormatted = dateToYYYYMMDD(currentDate);

        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear();
        const customDateFormat = `${day}.${month}.${year}`;

        result.push({
            dateStr: currentDate.getDate() + ' ' + getMonthByDate(currentDate, true),
            weekDay: getWeekdayByDate(currentDate, true),
            date: dateFormatted,
            today: dateFormatted === dateToYYYYMMDD(today),
            past: currentDate < today,
            customDate: customDateFormat
        });

        currentDate.setDate(currentDate.getDate() + 1);
    }

    return result;
}